import { Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import Page from '../../components/Page';
import TabContainer from '../../components/TabContainer';
import withVenue from '../../hoc/withVenue';
import useEndpoint from '../../hooks/useEndpoint';
import useRoles from '../../hooks/useRoles';
import { clearBilling, fetchBilling } from '../../store/billing';
import { getBillingState } from '../../store/billing/selectors';
import { isMultivendor } from '../../store/venues/selectors';
import BillingPage from './Billing';
import BusinessPage from './Business';
import PaymentsPage from './Payments';
import TeamPage from './Team';
import SettingsPage from './Venue';

const Settings = () => {
  const { tabname, subtab } = useParams();
  const { isOwner, isAdmin } = useRoles();
  const typeMultivendor = useSelector(isMultivendor);
  const { data: subscriptionData } = useEndpoint(getBillingState, fetchBilling());
  const hasCustomer = subscriptionData?.customer;
  const showBilling = isOwner() && hasCustomer;
  const showBusiness = isAdmin() || (isOwner() && !typeMultivendor);

  const titles = ['Venue', 'Users', 'Payments'];
  if (showBilling) titles.push('Billing');
  // add 'Business' to titles array at index 1 if showBusiness is true
  if (showBusiness) titles.splice(1, 0, 'Business');

  const defaultTabName = tabname === 'billing' && !showBilling ? 'payments' : tabname;

  return (
    <Page>
      <Typography style={{ flexGrow: 1 }} variant="h2" component="h1">
        Settings
      </Typography>
      <TabContainer
        titles={titles}
        defaultTab={subtab ? '' : defaultTabName}
        path="/settings/"
        subtab={subtab}
        pageTab="users"
      >
        <SettingsPage />
        {showBusiness && <BusinessPage />}
        <TeamPage />
        <PaymentsPage />
        {showBilling && <BillingPage />}
      </TabContainer>
    </Page>
  );
};

export default withVenue(Settings, null, clearBilling);
